import api from '../common/helpers/apiHelper';
import { IGlobalSearchFilter } from '../common/models/filter/IGlobalSearchFilter';
import { IListData } from '../common/models/common/IListData';
import { Search } from '../common/models/search/Search';

export const getItems = (payload: IGlobalSearchFilter) => api.get<IListData<Search>>(
  '/api/search/',
  payload
);

export const fetchRecent = (payload: { ids: string[]; filter: IGlobalSearchFilter }) => api.get<IListData<Search>>(
  '/api/search/recent',
  payload
);
